'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:dismiss');
}

var _invoke = require('../invoke');

/**
 * 关闭当前 modal
 *
 * 与 `hbnb.webivew.modal` 配合使用
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof webview
 * @static
 * @name dismiss
 * @example
 *  hbnb.webview.dismiss();
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }

    _invoke('webview', 'dismiss');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/hbnb/webview/dismiss.js
// module id = dGUj
// module chunks = 0